import { i18nMark } from 'lingui-react';

const messages = {
  defaultHeader: i18nMark('Assets'),
  description: i18nMark('The assets page of the application'),
  title: i18nMark('The Assets Page'),
};

export default messages;



// WEBPACK FOOTER //
// ./containers/AssetsPage/messages.js